export default __webpack_public_path__ + "static/media/koc_uzaktan.a7cde141.svg";